export const parseTargetDate = (value: string, fallbackYmd: string): Date => {
    const trimmed = value.trim();

    // Support YYYY-MM-DD as local midnight.
    const ymdMatch = /^\d{4}-\d{2}-\d{2}$/.exec(trimmed);
    if (ymdMatch) {
        const [yearStr, monthStr, dayStr] = trimmed.split('-');
        const year = Number(yearStr);
        const monthIndex = Number(monthStr) - 1;
        const day = Number(dayStr);
        return new Date(year, monthIndex, day, 0, 0, 0, 0);
    }

    // Otherwise, rely on Date parsing (e.g. 2026-07-01T12:00:00+02:00).
    const parsed = new Date(trimmed);
    if (Number.isNaN(parsed.getTime())) {
        return parseTargetDate(fallbackYmd, fallbackYmd);
    }
    return parsed;
};

export const startOfLocalDay = (date: Date): Date => new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);

export const addDays = (date: Date, days: number): Date => new Date(date.getFullYear(), date.getMonth(), date.getDate() + days, 0, 0, 0, 0);

export const countWorkdaysBetween = (startInclusive: Date, endExclusive: Date): number => {
    let count = 0;
    for (let cursor = new Date(startInclusive); cursor.getTime() < endExclusive.getTime(); cursor = addDays(cursor, 1)) {
        const day = cursor.getDay();
        const isWeekday = day >= 1 && day <= 5;
        if (isWeekday) count += 1;
    }
    return count;
};

export const countRemainingWorkdaysInclusive = (endDate: Date, now: Date): number => {
    const diffMs = endDate.getTime() - now.getTime();
    if (diffMs <= 0) return 0;

    const start = addDays(startOfLocalDay(now), 1);
    const endExclusive = addDays(startOfLocalDay(endDate), 1);
    return countWorkdaysBetween(start, endExclusive);
};
